<div class="row">
	<div class="col mx-auto message">
		<shared-media-component-media
			[image]="'DSG_CLP_404Error'"
			[itemTitle]="'DSG 404 Error'"
			[altText]="''"
			[willLazyLoad]="true">
		</shared-media-component-media>
		<div>
			<h1>404</h1>
			<strong>Time Out. We can't find that page.</strong>
			<p>The page you're looking for isn't available. Try a different page or use the Go Back button below.</p>
			<a href="javascript:void(0)" (click)="goBack()" class="d-flex justify-content-center">
				<homefield-icon class="material-icons" name="caret-left"></homefield-icon>
				Go Back
			</a>
		</div>

	</div>
</div>
